export const messageCodes = {
    CARD_EXPIRED: 0,
    COULD_NOT_CALCULATE_FREIGHT: 1,
    FILL_WITH_FULL_NAME: 2,
    FINALIZE_PAYMENT_ERROR: 3,
    INDENTIFY_INVALID: 4,
    INTERNATIONAL_BILLING_ADDRESS_IS_NOT_ENABLED: 5,
    INVALID_CARD_NUMBER: 6,
    INVALID_CHECKOUT_CIELO_CARD: 7,
    INVALID_CVV: 8,
    INVALID_FLAG_FOR_CARD_NUMBER: 9,
    INVALID_FORM_ZIPCODE_MANDATORY: 10,
    ORDER_ALREADY_PROCESSED_MESSAGE: 11,
    PLEASE_INFORM_HOLDER: 12,
    PRODUCT_REMOVED_OR_NOT_FOUND: 13,
    WRONG_OPERATION_RESULT_SAFETY_CHECK: 14,
    UNEXPECTED_AUTHENTICATION_ERROR: 15,
    CVV_REQUIRED: 16,
    OPENFINANCEURL_IS_NULL: 21,
};

export function getMessageLangParameter(code) {
    switch(code) {
    case messageCodes.CARD_EXPIRED: return 'cardExpired';
    case messageCodes.COULD_NOT_CALCULATE_FREIGHT: return 'couldNotCalculateFreight';
    case messageCodes.FILL_WITH_FULL_NAME: return 'fillWithFullName';
    case messageCodes.FINALIZE_PAYMENT_ERROR: return 'finalizePaymentError';
    case messageCodes.INDENTIFY_INVALID: return 'indentifyInvalid';
    case messageCodes.INTERNATIONAL_BILLING_ADDRESS_IS_NOT_ENABLED: return 'internationalBillingAddressIsNotEnabled';
    case messageCodes.INVALID_CARD_NUMBER: return 'invalidCardNumber';
    case messageCodes.INVALID_CHECKOUT_CIELO_CARD: return 'invalidCheckoutCieloCard';
    case messageCodes.INVALID_CVV: return 'invalidCvv';
    case messageCodes.INVALID_FLAG_FOR_CARD_NUMBER: return 'invalidFlagForCardNumber';
    case messageCodes.INVALID_FORM_ZIPCODE_MANDATORY: return 'invalidFormZipcodeMandatory';
    case messageCodes.ORDER_ALREADY_PROCESSED_MESSAGE: return 'orderAlreadyProcessedMessage';
    case messageCodes.PLEASE_INFORM_HOLDER: return 'pleaseInformHolder';
    case messageCodes.PRODUCT_REMOVED_OR_NOT_FOUND: return 'productRemovedOrNotFound';
    case messageCodes.WRONG_OPERATION_RESULT_SAFETY_CHECK: return 'wrongOperationResultSafetyCheck';
    case messageCodes.UNEXPECTED_AUTHENTICATION_ERROR: return 'unexpectedAuthenticationError';
    case messageCodes.CVV_REQUIRED: return 'cvvRequiredError';
    case messageCodes.OPENFINANCEURL_IS_NULL: return 'openFinanceUrlIsNull';
    default: return 'unexpectedError';
    }
}

export function getTitleMessageLangParameter(code) {
    switch(code) {
    case messageCodes.OPENFINANCEURL_IS_NULL: return 'openFinanceUrlIsNullTitle';
    default: return 'opsTitle';
    }
}
